import { Navigate } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-secondary">
        <Loader2 className="h-10 w-10 animate-spin text-accent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (!user.is_admin) {
    return (
      <div data-testid="not-authorized" className="min-h-screen grid place-items-center bg-secondary px-6">
        <div className="text-center max-w-md">
          <ShieldAlert className="h-14 w-14 text-destructive mx-auto mb-5" />
          <h1 className="font-heading font-extrabold text-2xl text-foreground">Access not permitted</h1>
          <p className="mt-3 text-muted-foreground text-lg">
            The account <strong>{user.email}</strong> isn't authorized for the owner dashboard.
          </p>
        </div>
      </div>
    );
  }

  return children;
};
